import React from "react";
import { FaTimes } from "react-icons/fa";
import "./Programas.css";

const Programas = ({ onClose }) => {
  return (
    <aside className="programas-panel">
      <button className="close-button" onClick={onClose}>
        <FaTimes />
      </button>
      <div className="programas-content">
        <h2>Programación de Lunes a Viernes</h2>
        <ul className="schedule">
          <li>
            <span className="time">6:00 AM - 8:00 AM</span>
            <span className="description">Bachata/Típica</span>
          </li>
          <li>
            <span className="time">8:00 AM - 12:00 PM</span>
            <span className="description">Música Variada</span>
          </li>
          <li>
            <span className="time">12:00 PM - 1:00 PM</span>
            <span className="description">Música Suave</span>
          </li>
          <li>
            <span className="time">1:00 PM - 4:00 PM</span>
            <span className="description">Música Variada</span>
          </li>
          <li>
            <span className="time">4:00 PM - 5:00 PM</span>
            <span className="description">El Tipicazo de las 4</span>
          </li>
          <li>
            <span className="time">5:00 PM - 6:00 PM</span>
            <span className="description">94 Grados Salsa</span>
          </li>
          <li>
            <span className="time">6:00 PM - 7:00 PM</span>
            <span className="description">Noble Bachata</span>
          </li>
          <li>
            <span className="time">7:00 PM - 8:00 PM</span>
            <span className="description">Salud y Religión</span>
          </li>
          <li>
            <span className="time">8:00 PM - 12:00 AM</span>
            <span className="description">Música Variada</span>
          </li>
        </ul>

        <h2>Programación del Sábado</h2>
        <ul className="schedule">
          <li>
            <span className="time">6:00 AM - 10:00 AM</span>
            <span className="description">Súper Fin de Semana Doble</span>
          </li>
          <li>
            <span className="time">10:00 AM - 2:00 PM</span>
            <span className="description">Noble Salsa del Sábado</span>
          </li>
          <li>
            <span className="time">2:00 PM - 12:00 AM</span>
            <span className="description">Súper Fin de Semana Noble</span>
          </li>
        </ul>

        <h2>Programación del Domingo</h2>
        <ul className="schedule">
          <li>
            <span className="time">10:00 AM - 1:00 PM</span>
            <span className="description">Los Superclásicos del Merengue</span>
          </li>
          <li>
            <span className="time">1:00 PM - 4:00 PM</span>
            <span className="description">Los Superclásicos de la Salsa</span>
          </li>
          <li>
            <span className="time">4:00 PM - 12:00 AM</span>
            <span className="description">Música Variada</span>
          </li>
        </ul>

        <div className="programas-info">
          <p>📻 Transmitimos desde Vicente Noble, en la provincia de Barahona, República Dominicana.</p>
          <p>🎶 Nuestra programación incluye merengue, salsa, bachata, música urbana, balada, rock y más.</p>
          <p>🌎 Nos enfocamos en difundir noticias y llegar a oyentes en todo el país y el mundo a través de nuestras plataformas digitales.</p>
          <p>¡Disfruta nuestra variada programación! 🎵📡</p><br></br>
        </div>
      </div>
    </aside>
  );
};

export default Programas;
